import { Injectable, WritableSignal, inject, signal } from "@angular/core";
import { BeforeUnloadService } from "src/app/services/before-unload.service";

@Injectable()
export class DirtyService {
  private readonly beforeUnloadService = inject(BeforeUnloadService);

  getInitialState(): WritableSignal<boolean> {
    return signal<boolean>(this.beforeUnloadService.isAcquired());
  }
}
